import type { AuthUser } from '@/stores/useAuthStore';

/** Nome completo do usuário, ou fallback ('' por padrão). */
export function fullName(user: AuthUser, fallback = ''): string {
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return name || user.username || fallback;
}

/** Iniciais (até 2 letras) para o avatar. */
export function initials(user: AuthUser, fallback = '?'): string {
  const parts = [user.firstName, user.lastName].filter(Boolean) as string[];
  if (parts.length === 0) {
    const src = user.username || user.emailAddress || '';
    return src ? src.slice(0, 2).toUpperCase() : fallback;
  }
  return parts
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
